import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Modal } from 'antd';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';
import { ProductListDataService } from 'src/app/products/products/list/product-list.data';
import { ProductFilterModalView} from 'src/app/products/products/form/parts/product-filter-modal.view'

interface ProductFilterModalProps extends ComponentViewProps<TourItineraryProductItem> {

	closeDialog: (ev?: React.MouseEvent<HTMLButtonElement>) => void;
	showModal: boolean;
	onProductChange :(record: TourItineraryProductItem) => (item: ProductSummary)=>void
}

@observer
export class ProductFilterModalController extends React.Component<ProductFilterModalProps, any> {
	@observable
	protected dataService: ProductListDataService;
	@observable
	showResult = false;
	@observable
	product: ProductSummary;
	@observable
	selectionKey: string;
	@resolve
	toast: ToastNotifications;
	constructor(props) {
		super(props);

	}



	@autobind
	async onSearchProduct(filter: ProductFilter) {
		this.dataService.removeAllFilter();
		for (let prop in filter) {
			if (prop == "searchKeywords") {
				this.dataService.searchKeywords = filter.searchKeywords;
			}
			else {
				if (filter[prop])
					this.dataService.addFilter((prop as any), "eq", filter[prop])
			}
		}
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.pageSize = 50;
		let res = await this.dataService.load(query => query);
		this.dataService.removeAllFilter();
		this.showResult = true;
	}
	@autobind
	onAcceptModal() {
		if (this.product.isLeaf ) {
			this.props.onProductChange(this.props.model)(this.product);
			this.props.closeDialog();
			this.showResult = false;
			this.product = null;
			this.selectionKey = null;
		}
		else {
			this.selectionKey = null;
			this.toast.showToast('Error', "The selected product should´nt have child", 'error');

		}
	
	}
	@autobind
	onSelectproduct(product: ProductSummary) {
		this.product = product;
		this.selectionKey=product.id.toString()
	}

	public componentDidMount() {
		this.dataService = ProductListDataService.make();
	}

	componentWillReceiveProps(nextProps: Readonly<ProductFilterModalProps>, nextContext: any) {
		
	}


	render() {
		if (this.dataService == null && this.props.model== null) {
			return null;
		}

		return (
			<Modal
				className="ant-modalClient"
				visible={this.props.showModal}
				onCancel={this.props.closeDialog}
				title="Search Product"
				maskClosable={false}
				width="80%"
				footer={[
					<Button key='ok' onClick={this.onAcceptModal} disabled={this.product==null} >Ok</Button>,

				]}>
				<ProductFilterModalView
					model={this.dataService}
					onSearchProduct={this.onSearchProduct}
					onSelectProduct={this.onSelectproduct}
					selectionKey={this.selectionKey}
					setBusy={this.props.setBusy}
					showResult={this.showResult}
					itinerary={this.props.model}
				/>
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-filter-modal.controller.tsx